const steps = [
  { icon: 'ri-search-line', title: '1. 选剧不迷路', desc: '用热播榜与分类快速圈定想看与在追的剧，告别「今晚不知看什么」的剧荒时刻。' },
  { icon: 'ri-calendar-check-line', title: '2. 日历踩准点', desc: '按剧集更新节奏排好本周日历，每部剧几点更新、哪天收官，全部提前掌握。' },
  { icon: 'ri-magic-line', title: '3. 速递快人一步', desc: '开启订阅后，每日追更速报直送你的邮箱，更新提醒永远走在吃瓜最前线。' },
  { icon: 'ri-team-line', title: '4. 一起开心吃瓜', desc: '看完速递来吃瓜区聊聊伏笔与名场面，和同好一起把剧情拆个明明白白。' },
];

const points = [
  '更新动态今晚集中刷新',
  '速递只导读不破坏悬念',
  '榜单每日实时计算',
  '六大分类覆盖热门好剧',
  '订阅与退订一键完成',
  '全程绿色，无资源盗链',
];

export default function Guide() {
  return (
    <section id="guide" className="scroll-mt-20 bg-[#3a332b] py-12 text-white md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto mb-10 max-w-2xl text-center">
          <p className="mb-2 text-xs font-bold uppercase tracking-widest text-[#f0a35f]">追更指南 · 如何不迷路</p>
          <h2 className="font-serif-sc text-2xl font-black text-white md:text-3xl">四步走，开启你的追更不迷路之旅</h2>
          <p className="mt-3 text-sm leading-7 text-white/70">
            从选剧到追更，我们把整套流程理顺，让「蹲点守候」变成「轻松跟上」，每一集高光都不错过。
          </p>
        </div>

        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {steps.map((s, i) => (
            <div key={s.title} className="relative rounded-2xl bg-white/[0.06] p-5 ring-1 ring-white/10">
              <div className="mb-3 flex items-center justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-[#e85d3f] text-xl text-white">
                  <i className={s.icon}></i>
                </span>
                <span className="font-serif-sc text-3xl font-black text-white/10">0{i + 1}</span>
              </div>
              <h3 className="mb-2 font-serif-sc text-base font-black text-white">{s.title}</h3>
              <p className="text-xs leading-6 text-white/65">{s.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-8 flex flex-wrap items-center gap-x-6 gap-y-3 rounded-2xl bg-white/[0.06] px-6 py-4 ring-1 ring-white/10">
          {points.map((p) => (
            <span key={p} className="flex items-center gap-2 text-xs font-medium text-white/80">
              <i className="ri-checkbox-circle-line text-[#7fb98a]"></i>
              {p}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}